var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.SingleProduct = (function ($, window, document) {
	function variation_form($form) {
		$form.on("found_variation", function (event, variation, purchaseable) {
			// event.preventDefault();
			$price_html = $(variation.price_html);
			$price_html.prepend("<span>From </span>");

			$(this).closest(".product").find(".price").replaceWith($price_html);
		});
	}

	return {
		init: function () {
			if (typeof wc_add_to_cart_variation_params !== "undefined") {
				$(".variations_form").each(function () {
					variation_form($(this));
				});
			}
		},
	};
})(window.jQuery, window, document);
